<template>
  <div>
    <h3>Reply</h3>
    <p>
      Enter a message in the box and click button to send. Also indicate if you
      wish to save this message as a standard response for future use.
    </p>
    <v-textarea autofocus placeholder="Message body" v-model="body" outline />
    <v-select
      :items="folders"
      v-model="folderId"
      label="Choose a folder to save this message to:"
      item-text="name"
      item-value="id"
      outline
    />
    <v-btn @click="createMessage" :disabled="submitted" :loading="submitted">
      <v-icon>send</v-icon>Send reply
    </v-btn>
    <v-btn @click="$emit('reset')">Cancel</v-btn>
  </div>
</template>

<script>
import FOLDERS from "@/graphql/message/Folders";
export default {
  name: "FreeText",
  apollo: {
    folders: {
      query: FOLDERS,
      fetchPolicy: "cache-and-network"
    }
  },
  data() {
    return {
      body: null,
      folderId: null,
      submitted: false
    };
  },
  methods: {
    createMessage() {
      this.submitted = true;
      if (this.folderId == null) {
        this.$emit("create", { body: this.body });
      } else {
        this.$emit("createResponse", {
          folderId: this.folderId,
          body: this.body
        });
      }
    }
  }
};
</script>

<style>
</style>
